type OpenCallSubmissionLinkParams = {
  openCallId: string;
  submissionId: string;
};

const submissionPermalinkUrl = (submission: OpenCallSubmissionLinkParams) =>
  `/open-calls/${submission.openCallId}/submissions/${submission.submissionId}`;

const submissionEditUrl = (submission: OpenCallSubmissionLinkParams) =>
  `/open-calls/${submission.openCallId}/submissions/${submission.submissionId}/edit`;

const submissionVoteUrl = (submission: OpenCallSubmissionLinkParams) =>
  `/open-calls/${submission.openCallId}/vote?submission=${submission.submissionId}`;

export { submissionPermalinkUrl, submissionEditUrl, submissionVoteUrl };
